import styled from 'styled-components';
import { Button, Form } from 'antd';
import { IToken, ThemeList } from 'store/ducks/globalTypes';
import { variablesList } from 'constants/variablesList';
import { IThemeSelectorProps } from 'store/ducks/Global/types';

export const StyledContainer = styled('div')<IThemeSelectorProps>`
  overflow-y: hidden;
  min-height: 100vh;
  background-color: ${(props) =>
    variablesList[props.theme as unknown as ThemeList].bgColor};
  background-repeat: no-repeat;
  margin-left: auto;
  margin-right: auto;
  background-size: cover;

  .ant-pagination {
    margin: 10px 0;
  }
`;

export const StyledLinkButton = styled(Button)<IToken>`
  padding: unset;
  line-height: inherit;
  margin-right: ${(props) => `${props.token.marginXXS}px`};

  > span {
    text-decoration: underline;

    &:hover {
      text-decoration: none;
    }
  }
`;

export const StyledButton = styled(Button)<IToken>`
  min-width: 150px;
  margin-top: ${(props) => `${props.token.marginXS}px`};
  border-radius: ${(props) => `${props.token.borderRadiusSM}px !important`};
`;

export const StyledFormItem = styled(Form.Item)<IToken>`
  margin-bottom: ${(props) => `${props.token.margin}px`};

  .ant-input,
  .ant-input-affix-wrapper {
    padding: 8px 10px;
    border-radius: ${(props) => `${props.token.borderRadiusSM}px`};
  }

  .ant-col {
    min-width: 100%;
  }
`;

export const FormContainer = styled('div')<IToken>`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 10px;
  background: white;
  padding: 20px 0;
  min-height: 100%;
  border: 1px solid #5a6f94;

  > .ant-typography {
    margin: 0;
  }

  .ant-row {
    justify-content: space-between;

    a span {
      color: black;
    }
  }

  > .ant-form {
    min-width: 315px;
    margin-top: ${(props) => `${props.token.marginLG}px`};
  }
`;

export const IconContainer = styled('div')<IToken>`
  background: ${(props) => props.token.colorPrimary};
  padding: ${(props) => `${props.token.paddingSM}px`};
  border-radius: 50%;

  > span {
    font-size: ${(props) => `${props.token.fontSizeXL}px`};
    color: ${(props) => props.token.colorPrimaryText};
  }
`;

export const InputForm = styled('div')`
 position: relative,
 margin-bottom: 20px
`;

export const ActiveUsers = styled('div')`
  margin-top: 24px;

  .ant-transfer-list {
    .ant-wave-target {
      border: 1px solid;
    }
  }
`;

export const SubmitContainer = styled('div')`
  width: fit-content;
  margin: auto;
`;

export const ViewUsersContainer = styled('span')`
  padding: 10px;
  width: -webkit-fill-available;
  max-height: 620px;
  overflow: scroll;

  .ant-btn-icon {
    color: white;
  }

  .ant-list-item {
    border-bottom: 1px solid;
  }

  .ant-typography {
    padding: 0;
  }
`;

export const MainTabs = styled('div')`
  display: flex;
  justify-content: center;

  button {
    margin-right: 8px;
  }
`;

export const SelectedCompany = styled('div')`
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
